import {buildResultsHeaderText, ISearchType, searchTypesDisplayMap} from "./SearchPage";
import React, {PropsWithChildren, ReactElement} from "react";

export function ResultsHOC(props: PropsWithChildren<{
    resultsCount: number,
    searchTypes: ISearchType[],
    thisComponentType: ISearchType,
    isValidating: boolean,
    isLoading: boolean,
    searchTerm: string,
    noResultsString: string,
    noResultsOptions?: ReactElement,
}>) {
    if (props.isLoading || props.searchTerm === "") {
        return <></>
    } else if (props.resultsCount === 0) {
        return <div>
            <h3>{buildResultsHeaderText(props.resultsCount, searchTypesDisplayMap[props.thisComponentType], props.searchTerm)}</h3>
            {props.noResultsOptions}
            <small>Your search - <span style={{fontWeight: 700}}>{props.searchTerm}</span> - did not match any {props.noResultsString}.</small>
        </div>
    }

    return <div>
        <h3>{buildResultsHeaderText(props.resultsCount, searchTypesDisplayMap[props.thisComponentType], props.searchTerm)}</h3>
        {props.children}
    </div>;
}
